import ValidateButton from './ValidateButton'

export default ValidateButton
